import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-admin-top-nav',
  templateUrl: './admin-top-nav.component.html',
  styleUrls: ['./admin-top-nav.component.css']
})
export class AdminTopNavComponent implements OnInit {
  isCollapsede:boolean=true;

  role_id:any=0;
  user_list_per:boolean=false;

  constructor(  private _router : Router,) { }

  ngOnInit() {
    this.role_id =localStorage.getItem('role_id');
    if(this.role_id==1){this.user_list_per=true;}
  }


   
  redirectPage(url){
     // this._router.navigate(["/super-admin/customer-list/active"]);
     this._router.navigateByUrl('/redirect').then(() => {
         this._router.navigate([url]);
     });


  }




}
